<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M18.5 4.6 18 4V3q0-.5-.5-.5h-11Q6 2.5 6 3v1q0 .5-.5.6h-3Q2 4.6 2 5v2.4a5 5 0 0 0 4 4.9q.3 0 .4.3a6 6 0 0 0 4.2 3.6q.3.1.4.5v.7a2 2 0 0 1-2 2h-.5q-.5 0-.5.5v1q0 .5.5.5h7q.5 0 .5-.5v-1q0-.5-.5-.5H15a2 2 0 0 1-2-2v-.7q0-.3.4-.5a6 6 0 0 0 4.2-3.6q0-.3.4-.3a5 5 0 0 0 4-4.9V5.1q0-.5-.5-.5zM4 7.5v-.4q0-.5.5-.5h1q.5 0 .5.5v2.5q0 .6-.6.4A3 3 0 0 1 4 7.5m16 0a3 3 0 0 1-1.4 2.5q-.5.3-.6-.4V7.1q0-.5.5-.5h1q.5 0 .5.5z"
    />
  </svg>
</template>
